import { defineMessages } from 'react-intl';

export default defineMessages({
  filenamePlaceholder: {
    id: 'frontbucket.repository.source.filePath.filenamePlaceholder',
    description: 'Placeholder text for an input field for naming a file',
    defaultMessage: 'Add your file name...',
  },
});
